import { axiosWithoutToken } from 'common/utils/axiosHelper';
import { loginIndividualDemoLinkAccount } from 'individualDemoLink/api';
import { loginUser, loginDemoAccount } from 'userAuth/api/authApi';
import ReactGA from 'react-ga4';

const getUserData = (token) =>
  axiosWithoutToken.get(`${process.env.REACT_APP_API_URL}/users/me`, {
    params: {
      relations: true,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const authenticateUser = (username, password) =>
  loginUser({
    username,
    password,
    grant_type: 'password',
    client_id: `${process.env.REACT_APP_CLIENT_ID}`,
    client_secret: `${process.env.REACT_APP_CLIENT_SECRET}`,
  }).then((tokenResponse) =>
    getUserData(tokenResponse.data.access_token).then((userDataResponse) => {
      ReactGA.event({
        category: 'Auth',
        action: 'Login',
        label: 'Successful Auth',
      });
      return {
        token: tokenResponse.data.access_token,
        userData: userDataResponse.data,
      };
    }),
  );

const authenticateDemoUser = () =>
  loginDemoAccount().then((tokenResponse) =>
    getUserData(tokenResponse.data.access_token).then((userDataResponse) => {
      return {
        token: tokenResponse.data.access_token,
        userData: userDataResponse.data,
      };
    }),
  );

const authenticateIndividualLinkUser = (individualLink) =>
  loginIndividualDemoLinkAccount(individualLink).then((tokenResponse) =>
    getUserData(tokenResponse.data.access_token).then((userDataResponse) => {
      return {
        entitiableType: tokenResponse.data.entitiable_type,
        entitiableId: tokenResponse.data.entitiable_id,
        token: tokenResponse.data.access_token,
        userData: userDataResponse.data,
      };
    }),
  );

export {
  authenticateUser,
  authenticateDemoUser,
  authenticateIndividualLinkUser,
};
